import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import firebase from 'firebase/app'
import 'firebase/auth'


const userDefaults = {}

const label_chi = {
  menu: '選單',
  res_type: '餐廳類型',
  found_1: '找到',
  found_2: '間營業中的餐廳',
  no_resMsg: '抱歉! 暫時沒有營業中的餐廳',
  res_dish: '餐廳菜式',
  find_rest: '搜尋餐廳',
  select: '選取餐廳',
  selectRestaurant: '選擇餐廳',
  saiKung: '西貢',
  accept: '確認提交',
  back: '返回',
  mealOption: '套餐選項',
  choose: '選擇',
  no_food: '此餐廳現時沒有可供預訂食物',
  curr_rest: '當前餐廳: ',
  mfound_1: '搵到',
  mfound_2: '個餐',
  mealCategory: '餐單分類',
  searchFood: '搜尋食物',
  addToCart: '加到訂單',
  add: '+',
  limitMsg: '每張訂單只限十份食物，如有需要請分單，謝謝。',
  tips: '提示',
  cart: '外賣籃',
  set: '份',
  with: '配',
  qty: '數量',
  del: '移除',
  orderDetails: '訂單明細',
  qtyOrder: '份外賣',
  shipping: '運費',
  minCharge: '本店設有最低消費',
  minChargePayment: '最低消費補差額',
  estimate: '預計運送時間: 1小時',
  total: '合共總數',
  next: '下一步',
  noFood: '外賣籃未有野食！',
  findFood: '搵野食',
  orderAddress: '外賣地址',
  writeAddress: '填寫地址資料',
  toAddressMsg: '我地將會把外賣送至以下地址',
  custName: '姓名',
  fillNameMsg: '請填上中文或英文姓名',
  phone: '聯絡電話',
  fillPhoneMsg: '請填上可以聯絡你的電話',
  fillAddressMsg: '請填上收取外賣地址',
  address: '地址欄',
  dist: '地區(暫時只限西貢)',
  selectDist: '請選擇地區',
  saveNext: '儲存及下一步',
  address1: '地址1：',
  address2: '地址2：',
  phoneNum: '電話號碼：',
  paymeMsg: '以 PayMe 付款，訂單會在確認付款後開始送出。',
  paymentMethod: '付款方式',
  pay: '付款',
  toDelivererMsg: '給外送員的提示',
  confirmOrder: '確認訂單',
  confirmOrderTitle: '訂單確認',
  deliverDetail: '運送詳情',
  totalLabel: '合共',
  deliveryFee: '總數不包含運費',
  shipAddress: '運送地址',
  findOrder: '搜尋訂單',
  inputOrderPhone: '請輸入訂單的電話號碼',
  find: '搜尋',
  refresh: '刷新',
  wp: '待付款',
  orderNum: '訂單號碼',
  orderCreateDate: '建立時間',
  remarks: '備註:',
  deliverer: '送餐員電話',
  lastUpdate: '最後更新時間',
  orderCheck: '訂單查詢',
  noMore: '沒有更多了',
  sStatus: '運送中',
  pStatus: '準備中',
  cStatus: '已完成',
  chooseRest: '選擇餐廳',
  orderMeal: '點餐',
  checkout: '結帳',
  updated: '已更新餐廳列表',
  min: '設有最低消費',
  updatedlist: '已更新列表',
  added: '已加入',
  verifyInfo: '請檢查所輸入資料',
  success1: '訂單已送出',
  success2: '你將會很快收到我地既WhatsApp確認信息。',
  success3: '查看訂單'
}

const label_eng = {
  menu: 'Menu',
  res_type: 'Restaurant type',
  found_1: 'found',
  found_2: 'A restaurant in operation',
  no_resMsg: 'Sorry! There is no restaurant currently open',
  res_dish: 'Restaurant dishes',
  find_rest: 'Search restaurant',
  select: 'Select a restaurant',
  selectRestaurant: 'Select a restaurant',
  saiKung: 'Sai Kung',
  accept: 'Confirm submission',
  back: 'Return',
  mealOption: 'Package option',
  choose: 'Select',
  no_food: 'This restaurant currently has no food available for reservation',
  curr_rest: 'Current restaurant:',
  mfound_1: 'find it',
  mfound_2: 'meal',
  mealCategory: 'Meal Category',
  searchFood: 'Search Food',
  addToCart: 'Add to order',
  add: '+',
  limitMsg: 'Each order is limited to ten foods. Please divide the order if necessary, thank you. ',
  tips: 'tip',
  cart: 'Takeaway Basket',
  set: 'parts',
  with: 'With',
  qty: 'quantity',
  del: 'Remove',
  orderDetails: 'Order Details',
  qtyOrder: 'Takeaway',
  shipping: 'Shipping fee',
  minCharge: 'This shop has a minimum consumption',
  minChargePayment: 'Minimum consumption to make up the difference',
  estimate: 'Estimated delivery time: 1 hour',
  total: 'Total total',
  next: 'Next',
  noFood: 'There is no wild food in the takeaway basket! ',
  findFood: '搵野食',
  orderAddress: 'Takeaway address',
  writeAddress: 'Fill in address information',
  toAddressMsg: 'We will deliver the food to the following address',
  custName: 'Name',
  fillNameMsg: 'Please fill in Chinese or English name',
  phone: 'Contact number',
  fillPhoneMsg: 'Please fill in the phone number that can contact you',
  fillAddressMsg: 'Please fill in the delivery address',
  address: 'Address bar',
  dist: 'Region (for the time being only in Sai Kung)',
  selectDist: 'Please select a region',
  saveNext: 'Save and Next',
  address1: 'Address 1:',
  address2: 'Address 2:',
  phoneNum: 'Phone Number:',
  paymeMsg: 'Pay with PayMe, the order will be sent out after the payment is confirmed. ',
  paymentMethod: 'Payment Method',
  pay: 'Payment',
  toDelivererMsg: 'Tips for delivery staff',
  confirmOrder: 'Confirm order',
  confirmOrderTitle: 'Order Confirmation',
  deliverDetail: 'Shipping Details',
  totalLabel: 'Total',
  deliveryFee: 'Total does not include delivery fee',
  shipAddress: 'shipping address',
  findOrder: 'Search Order',
  inputOrderPhone: 'Please enter the phone number of the order',
  find: 'Search',
  refresh: 'Refresh',
  wp: 'Pending payment',
  orderNum: 'Order Number',
  orderCreateDate: 'Create Date',
  remarks: 'Remarks:',
  deliverer: 'deliverer phone',
  lastUpdate: 'Last update time',
  orderCheck: 'Order Check',
  noMore: 'No more',
  sStatus: 'Shipping',
  pStatus: 'In preparation',
  cStatus: 'Completed',
  chooseRest: 'Choose a restaurant',
  orderMeal: 'Order Meal',
  checkout: 'Checkout',
  updated: 'Restaurant list has been updated',
  min: 'There is a minimum consumption',
  updatedlist: 'Updated list',
  added: 'added',
  verifyInfo: 'Please check the information entered',
  success1: 'Order has been sent',
  success2: 'You will receive my WhatsApp confirmation message soon. ',
  success3: 'View order'
}

const state = {
  AppActiveUser: userDefaults,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,
  orders: [],
  cartItems: [],
  wishList: [],
  wishRestaurant: [],
  selectedRestaurant: [],
  windowWidth: null,
  orderList: [],
  currentItem: {},
  orderDisplayList: [],
  language: 'zh',
  getLabel: (lang) => {
    if (lang == 'en')
      return label_eng;
    else return label_chi;
  },
  isUserLoggedIn: () => {
    let isAuthenticated = false

    const firebaseCurrentUser = firebase.auth().currentUser

    if (firebaseCurrentUser && !firebaseCurrentUser.isAnonymous) isAuthenticated = true
    else isAuthenticated = false
    return (localStorage.getItem('userInfo') && isAuthenticated)
  },
  getUserInfo: () => {
    const firebaseCurrentUser = firebase.auth().currentUser

    return firebaseCurrentUser
  },
}

export default state